import React, { useEffect, useState } from "react";
import { HodEmployeeActiveList, AdminEmployeeActiveList, GetDirectorReportEmployee, findAllAparReport } from "../../Repository/Api";
import { errorMsg, successMsg } from "../Toastify";
import { useSelector } from "react-redux";
import ReactSelect from "react-select";
import { NonEmptyValidation } from "../../Store/validate";
import { Link, useLocation } from "react-router-dom";
import { FinancialYearFrom2024, YearView } from "../Common/FinancialYear";
const HodAnnualPerformanceReport = () => {
  const { first_name, access_token, department } = useSelector((state) => state?.auth?.auth);
  const token = access_token
  const { pathname } = useLocation()
  const isHod = pathname.includes('Hod')
  const isDirector = pathname.includes('Director')
  const isAdmin = pathname.includes('admin')

  const initialApplyState = {
    employee_id: [],
    academic_year: [],
  };

  const [apply, setApply] = useState(initialApplyState);
  
  const [report, setReport] = useState({});
  
  const [validation, setValidation] = useState({});
  const [employee, setEmployee] = useState([]);
  const [editReport, setEditReport] = useState({});
  const [active, setActive] = useState(0);
  const links = ["Pending with me", "Submitted"];
  const showSelected = (index) => {
    setActive(index);
  };
  useEffect(() => {
    getEmployeeList();
    getReport()
  }, [active]);
  const setData = (e, key) => {
    setApply({ ...apply, [key]: e });
    setEditReport({ ...editReport, [key]: e });
    if (validation[key]) setValidation({ ...validation, [key]: false });
  };

  const getReport = async () => {
    let Payload = {}
    const response = await findAllAparReport(Payload, token)
    if (response && response?.statusCode === 200) {
      if (isDirector) {
        if (active === 0) {
          setReport(response?.data?.filter(a => a.director_final_score === 0))
        } else {
          setReport(response?.data)
        }
      } else {
        setReport(response?.data)
      }
    }
  }


  const getEmployeeList = async () => {
    const response = pathname?.includes('Director') ? await GetDirectorReportEmployee(token) : pathname.includes('Hod') ? await HodEmployeeActiveList(token) : pathname?.includes('admin') && await AdminEmployeeActiveList(token)
    if (response && response.statusCode === 200) {
      let employee = pathname?.includes('Director') ?
        response?.data?.map((label) => ({
          label: label.name,
          value: label.id,
        })) :
        pathname?.includes('Hod') ?
          response?.data?.employee_details?.map((label) => ({
            label: label.first_name + ' ' + label.last_name,
            value: label.id,
          })) :
          pathname?.includes('admin') ?
            response?.data?.employee_details?.map((label) => ({
              label: label.first_name + ' ' + label.last_name,
              value: label.id,
            })) : ''
      setEmployee(employee);
    } else {
      errorMsg(response.message);
    }
  };
  const handleSubmit = async (e) => {
    e.preventDefault();

    let validate = {};
    validate.employee_id = NonEmptyValidation(apply?.employee_id);
    validate.academic_year = NonEmptyValidation(apply?.academic_year);

    setValidation(validate);

    if (Object.values(validate).every((v) => v.status === true)) {
      const Payload = {
        ...apply,
        employee_id: apply?.employee_id?.value,
      };
      const response = await findAllAparReport(Payload, token);
      if (response && response.statusCode === 200) {
        if (isDirector) {
          if (active === 0) {
            setReport(response?.data?.filter(a => a.director_final_score === 0))
          } else {
            setReport(response?.data)
          }
        } else {
          setReport(response?.data)
        }
        successMsg(response?.message)
      } else {
        errorMsg(response.message);
      }
    }
  };

  return (
    <>
      <div className="">
        <section className="top-content-container">
          <div className="my-4">
            <div className="row">
              <div className="col-lg-6">
                <h6 className="headertext">{first_name}</h6>
                <h6 className="subheadertext">{department}</h6>
              </div>
              {isHod &&
                <div className="col-lg-6">
                  <div className="headeralign">
                    <Link to={
                      `/app/Hod/Generate/AnnualPerformanceAssessmentReport`
                    }>
                      <button
                        className="requestbtn"
                      >
                        Generate Report
                      </button>
                    </Link>
                  </div>
                </div>
              }
            </div>
          </div>
        </section>
        <section>
          <div className="row">
            <div className="">
              <div className="graphbox">
                <div className="row">
                  <div className="col-12 p-0 ">
                    <h6 className="labeltitle"> Annual Performance Assessment Report</h6>
                  </div>
                </div>
                {isDirector &&
                  <div className="row">
                    <div className="col-lg-12">
                      <ul className="searchtopflex">
                        {links.map((link, index) => {
                          return (
                            <li
                              onClick={() => showSelected(index)}
                              key={link}
                              className={
                                active === index
                                  ? "agenttextactive"
                                  : "agenttextinactive"
                              }
                            >
                              {link}
                            </li>
                          );
                        })}
                      </ul>
                    </div>
                  </div>}
                <div className="row mt-3">
                  <div className="col-lg-3">
                    <label className="labeltext"> Employee Name *</label>
                    <div>
                      <ReactSelect
                        isMulti={false}
                        value={apply?.employee_id}
                        onChange={(e) => {
                          setData(e, "employee_id");
                        }}
                        options={
                          employee
                        }
                      />
                    </div>
                    <small className="validationerror">
                      {validation?.employee_id?.message
                        ? `Employee ${validation?.employee_id?.message}`
                        : ""}
                    </small>
                  </div>
                  <div className="col-lg-3">
                    <label className="labeltext"> Academic Year *</label>
                    <div>
                      <ReactSelect
                        isMulti={false}
                        value={{
                          label: apply.academic_year,
                          value: apply.academic_year,
                        }}
                        onChange={(selectedOption) =>
                          setData(selectedOption.value, "academic_year")
                        }
                        options={FinancialYearFrom2024()}
                      />
                    </div>
                    <small className="validationerror">
                      {validation?.academic_year?.message
                        ? `Year ${validation?.academic_year?.message}`
                        : ""}
                    </small>
                  </div>
                  <div className="col-lg-3 mt-5">
                    <button
                      type="submit"
                      className="requestbtn"
                      onClick={(e) => handleSubmit(e)}
                    >
                      Get Report
                    </button>
                  </div>
                </div>
                <table className="table table-hover mt-4">
                  <thead>
                    <tr>
                      <th scope="col">Employee Name</th>
                      <th scope="col">Year</th>
                      <th scope="col">Application</th>
                    </tr>
                  </thead>
                  <tbody>
                    {report?.length > 0 ? (
                      report &&
                      report?.map((apply, index) => (
                        <tr key={index}>
                          <td>{apply?.name ? apply?.name : "-"}</td>
                          <td>{apply?.academic_year ? YearView(apply?.academic_year) : "-"}</td>
                          <td className="viewoption">
                            <Link
                              to={
                                isHod ? `/app/Hod/AnnualPerformanceAssessmentReport/${apply?.id}` :
                                  isDirector ? `/app/Director/AnnualPerformanceAssessmentReport/${apply?.id}` :
                                    isAdmin ? `/app/admin/AnnualPerformanceAssessmentReport/${apply?.id}` : ''
                              }
                            >
                              View
                            </Link>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td></td>
                        <td>
                          <div> No Data Found</div>
                        </td>
                        <td></td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default HodAnnualPerformanceReport;
